import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/plugins"; //Global Plugins
Vue.config.productionTip = false;
import store from "./store";
import "@/global";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
